"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomBarChart_1 = __importDefault(require("@/components/charts/CustomBarChart"));
const CustomLineChart_1 = __importDefault(require("@/components/charts/CustomLineChart"));
const Section_1 = __importDefault(require("@/components/layout/Section"));
const SimpleTable_1 = __importDefault(require("@/components/list/SimpleTable"));
const fetchData_1 = require("@/utils/fetchData");
const react_1 = __importStar(require("react"));
const vis_network_1 = require("vis-network/standalone/esm/vis-network");
const react_router_dom_1 = require("react-router-dom");
const format_1 = require("@/utils/format");
const styled_components_1 = require("styled-components");
const themes_1 = require("@/theme/themes");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const stakes_1 = require("../stakes/stakes");
const aboutUs_1 = require("../aboutUs");
const IconLogo_1 = __importDefault(require("@/assets/icons/IconLogo"));
const Loading_1 = require("@/components/layout/Loading");
const react_2 = require("@connect2ic/react");
const options = {
    nodes: {
        font: {
            color: '#ffffff',
            size: 14,
            face: 'Montserrat, arial',
            background: 'none',
            strokeWidth: 0,
            strokeColor: '#ffffff',
            align: 'center',
            multi: false,
            vadjust: 0,
            bold: {
                color: '#343434',
                size: 14,
                face: 'Montserrat, arial',
                vadjust: 0,
                mod: 'bold'
            },
        },
    },
    edges: {
        font: {
            face: 'Montserrat',
        },
        width: 2
    },
    interaction: {
        selectable: false,
        dragNodes: false,
        navigationButtons: true,
        zoomView: false,
    },
    physics: {
        // solver: 'repulsion',
        // stabilization: {
        //   iterations: 200,
        // },
        barnesHut: {
            theta: 0.1,
            avoidOverlap: 0.7,
            //springLength: 100,
            //springConstant: 0.01,
            gravitationalConstant: -12000,
            //centralGravity: 5,
            //springConstant: 0.1,
        },
        minVelocity: 5,
        maxVelocity: 10,
    },
};
const colors = {
    in: {
        border: "#0AB57F",
        color: "#0AB57F",
        background: "#F7FFFC",
    },
    out: {
        border: "#FB7474",
        color: "#FB7474",
        background: "#FFF4F4",
    },
    inOut: {
        border: "#74D1EF",
        color: "#74D1EF",
        background: "#EDFBFF",
    },
};
const LedgerAccountSpecific = () => {
    const params = (0, react_router_dom_1.useParams)();
    const [timeseries, setTimeseries] = (0, react_1.useState)();
    const [mapSearch, setMapSearch] = (0, react_1.useState)("");
    const [mapFilter, setMapFilter] = (0, react_1.useState)("");
    const [mapAmount, setMapAmount] = (0, react_1.useState)(100);
    const [history, setHistory] = (0, react_1.useState)();
    const [fullHistory, setFullHistory] = (0, react_1.useState)([]);
    const [filteredHistory, setFilteredHistory] = (0, react_1.useState)([]);
    const [modalOpenItems, setModalOpenItems] = (0, react_1.useState)();
    const [data, setData] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [balance, setBalance] = (0, react_1.useState)(null);
    const [maxBalance, setMaxBalance] = (0, react_1.useState)(null);
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    const [network, addNetwork] = (0, react_1.useState)(null);
    const [ledgerActor] = (0, react_2.useCanister)('ledger', { mode: 'connected' });
    const [dataError, setDataError] = (0, react_1.useState)(false);
    const [total, setTotal] = (0, react_1.useState)(0);
    const ref = (0, react_1.useRef)(null);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const generateDataFromNodes = (nodes, parentNodeId, initialData = {}) => ({
        nodes: [initialData, ...nodes],
        edges: nodes.map((node) => ({
            from: parentNodeId,
            to: node.id,
            dashes: [1, 4],
            font: {
                multi: "markdown",
                color: isDarktheme ? "#1A1D1E" : "#525252",
                strokeWidth: 0,
                strokeColor: isDarktheme ? "#1A1D1E" : "#525252",
            },
            label: node.count > 1 ? `     ${node.count} transactions \n ${(0, format_1.formatFloatAmount)(node.amount.toFixed(2), "'")} OGY   ` : `     ${(0, format_1.formatFloatAmount)(node.amount.toFixed(2), "'")} OGY     `,
            title: node.isTo && node.isFrom ? `Out: ${node.toAmount} \nIn: ${node.fromAmount} \n Total: ${Math.abs(node.amount.toFixed(2))} OGY` : `Total: ${Math.abs(node.amount.toFixed(2))} OGY`,
            arrows: node.isTo && node.isFrom ? "to, from" : (node.isTo ? "to" : "from"),
            color: colors[node.isInitialTrans ? "inOut" : (node.isTo ? "out" : "in")]
        })),
    });
    const getFullHistory = async () => {
        try {
            const result = await Promise.all([
                (0, fetchData_1.getTransactionHistoryById)(params.id, 1, mapAmount)
            ]);
            const [fullHistory] = await Promise.all(result);
            console.log(fullHistory);
            setFullHistory(fullHistory.data.map((h) => ({
                to: h.to[0].props.label,
                data: h,
                from: h.from[0].props.label,
                amount: h.amount[0].props.amount,
                hash: h.txHash[0].props.id,
            })));
        }
        catch (e) {
            console.log(e);
        }
    };
    const getData = async () => {
        setIsLoading(true);
        try {
            const balanceOGY = (await ledgerActor.account_balance_dfx({
                account: params.id,
            }));
            console.log(balanceOGY);
            const result = await Promise.all([
                (0, fetchData_1.getLedgerTimeseriesById)(params.id),
                (0, fetchData_1.getTransactionHistoryById)(params.id, 1, 10)
            ]);
            const [timeseriesResult, historyResult] = await Promise.all(result);
            const history = historyResult;
            console.log(history);
            const timeseries = timeseriesResult;
            let max = 0;
            timeseriesResult.maxBalance.forEach((b) => {
                if (parseFloat(b?.balance?.toString()) > max) {
                    max = parseFloat(b?.balance?.toString());
                }
            });
            setTotal(Number(historyResult.totalNumber));
            setMaxBalance(max);
            setBalance((0, format_1.formatNatAmount)(balanceOGY.e8s));
            setHistory(history);
            setTimeseries(timeseries);
            setIsLoading(false);
        }
        catch (e) {
            setDataError(true);
            console.log(e);
        }
    };
    (0, react_1.useEffect)(() => {
        let filtered = fullHistory;
        console.log("fullHistory", filtered);
        if (mapSearch) {
            filtered = filtered.filter((item) => item.to.includes(mapSearch) || item.from.includes(mapSearch));
        }
        if (mapFilter) {
            filtered = filtered.filter((item) => mapFilter === "In" && item.to === params.id || mapFilter === "Out" && item.from === params.id);
        }
        setFilteredHistory(filtered);
    }, [mapSearch, mapFilter, fullHistory]);
    (0, react_1.useEffect)(() => {
        getData();
    }, [params]);
    (0, react_1.useEffect)(() => {
        if (!isLoading) {
            getFullHistory();
        }
    }, [mapAmount, isLoading]);
    (0, react_1.useEffect)(() => {
        if (ref.current) {
            const hp = filteredHistory;
            console.log(filteredHistory);
            const accounts = hp.reduce((res, item, index) => {
                const result = res;
                const amount = parseFloat(item.amount.replace(/,/g, ""));
                if (item.from === params.id && item.to !== params.id) {
                    result[`i${item.to}`] = { ...result[`i${item.to}`], isTo: true, toAmount: (res[`i${item.to}`]?.toAmount || 0) + (amount), amount: (res[`i${item.to}`]?.amount || 0) + amount, count: (res[`i${item.to}`]?.count || 0) + 1, to: item.to, from: item.from };
                    if (mapAmount > total && index === (total - 1)) {
                        result[`i${item.to}`].isInitialTrans = true;
                        console.log("IsInit");
                    }
                }
                if (item.to === params.id && item.from !== params.id) {
                    result[`o${item.from}`] = { ...result[`o${item.from}`], isFrom: true, fromAmount: (res[`o${item.from}`]?.fromAmount || 0) + (amount), amount: (res[`o${item.from}`]?.amount || 0) + amount, count: (res[`o${item.from}`]?.count || 0) + 1, to: item.to, from: item.from };
                    if (mapAmount > total && index === (total - 1)) {
                        //result[`f${item.from}`] = { isInitialTrans: true, isFrom: true, fromAmount: amount, amount: amount, count: 1, to: item.to, from: item.from };
                        result[`o${item.from}`].isInitialTrans = true;
                        console.log("IsInit");
                    }
                }
                return (result);
            }, {});
            const initialData = generateDataFromNodes([
                ...(Object.keys(accounts).map((k) => ({
                    ...accounts[k],
                    id: k,
                    label: `${k.substring(1, 4)}...${k.substring(k.length - 3)}`,
                    font: {
                        color: colors[accounts[k].isInitialTrans ? "inOut" : (accounts[k].isTo ? "out" : "in")].border
                    },
                    margin: 25,
                    shape: "circle",
                    borderWidth: 2,
                    //mass: 15 - Math.pow(accounts[k].count, 1 / 3),
                    color: colors[accounts[k].isInitialTrans ? "inOut" : (accounts[k].isTo ? "out" : "in")]
                }))),
            ], params.id, {
                id: params.id,
                shape: "circle",
                label: `${params.id.substring(0, 4)}...${params.id.substring(params.id.length - 4)}`,
                margin: 20,
                physics: false,
                borderWidth: 2,
                color: {
                    border: "#5D627B",
                    background: "#5D627B",
                },
            });
            console.log(initialData);
            const instance = new vis_network_1.Network(ref.current, initialData, options);
            setData(initialData);
            addNetwork(instance);
        }
        return () => network?.destroy();
    }, [filteredHistory]);
    const handleTransactionsClose = () => {
        setModalOpenItems(null);
    };
    const handleTransactionsOpen = (edgeData) => {
        console.log(edgeData);
        console.log(filteredHistory, edgeData);
        const transactions = filteredHistory.filter((tr) => edgeData.arrows === "from" ? tr.from === edgeData.to.substring(1) : tr.to === edgeData.to.substring(1));
        console.log(transactions);
        setModalOpenItems(transactions);
    };
    (0, react_1.useEffect)(() => {
        if (network) {
            network.on('click', function (properties) {
                var nodeId = network.getNodeAt({ x: properties.event.srcEvent.offsetX, y: properties.event.srcEvent.offsetY });
                console.log(properties, network);
                if (nodeId) {
                    window.location.href = (`/account/${String(nodeId).slice(1)}`);
                    return;
                }
                if (properties.items.length && properties.items[0]?.edgeId) {
                    handleTransactionsOpen(data.edges.find(({ id }) => id === properties.items[0]?.edgeId));
                }
            });
        }
    }, [network]);
    if (params?.id?.length !== 64) {
        return (react_1.default.createElement(origyn_art_ui_1.Container, { padding: '48px', mdPadding: '24' },
            react_1.default.createElement(origyn_art_ui_1.Flex, { style: { minHeight: "60vh" }, gap: 32, align: "center", justify: "center", fullHeight: true, fullWidth: true, flexFlow: 'column' },
                react_1.default.createElement("h1", null, "404"),
                react_1.default.createElement("h4", null, "Page Not found"))));
    }
    return (react_1.default.createElement(origyn_art_ui_1.Container, { padding: '48px', mdPadding: '24' },
        dataError ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(origyn_art_ui_1.Container, { padding: '48px', mdPadding: '24' },
                react_1.default.createElement(origyn_art_ui_1.Flex, { style: { minHeight: "60vh" }, gap: 32, align: "center", justify: "center", fullHeight: true, fullWidth: true, flexFlow: 'column' },
                    react_1.default.createElement("h1", null, "404"),
                    react_1.default.createElement("h4", null, "Can't find account data in Ledger")))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h1", { style: { marginBottom: 32 } }, "OGY account"),
            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 32 },
                react_1.default.createElement(origyn_art_ui_1.Grid, { columns: 2, gap: 32 },
                    react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, padding: '24px' },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", fullWidth: true },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 13, fontWeight: 400, opacity: 0.7 }, align: "center", gap: 4 }, "AccountID"),
                            react_1.default.createElement(stakes_1.PrincipalBlock, { style: { fontSize: 24, fontWeight: 600, opacity: 1 }, text: params.id }))),
                    react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, padding: '24px' },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column" },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 13, fontWeight: 400, opacity: 0.7 }, align: "center", gap: 4 }, "Balance"),
                            isLoading
                                ? react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(Loading_1.LoadingBox, { style: { width: 200 } }))
                                : react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 24, fontWeight: 600 }, align: "center", gap: 4 },
                                        (0, format_1.toLocaleNumber)(balance),
                                        " ",
                                        react_1.default.createElement(aboutUs_1.CustomIcon, { size: "21" },
                                            react_1.default.createElement(IconLogo_1.default, null))),
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 12, fontWeight: 400 }, align: "center", gap: 4 },
                                        react_1.default.createElement("span", { style: { opacity: 0.7 } },
                                            "Historical max balance: ",
                                            react_1.default.createElement("b", null, (0, format_1.toLocaleNumber)(maxBalance))),
                                        react_1.default.createElement(aboutUs_1.CustomIcon, { size: "11" },
                                            react_1.default.createElement(IconLogo_1.default, null))),
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 12, fontWeight: 400 }, align: "center", gap: 4 },
                                        react_1.default.createElement("span", { style: { opacity: 0.7 } },
                                            "Genesis balance: ",
                                            react_1.default.createElement("b", null, (0, format_1.toLocaleNumber)(timeseries?.initial?.genesisBalance || 0))),
                                        react_1.default.createElement(aboutUs_1.CustomIcon, { size: "11" },
                                            react_1.default.createElement(IconLogo_1.default, null))),
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 12, fontWeight: 400 }, align: "center", gap: 4 },
                                        react_1.default.createElement("span", { style: { opacity: 0.7 } },
                                            "Initial Distribution balance: ",
                                            react_1.default.createElement("b", null, (0, format_1.toLocaleNumber)(timeseries?.initial?.initialDistributionBalance || 0))),
                                        react_1.default.createElement(aboutUs_1.CustomIcon, { size: "11" },
                                            react_1.default.createElement(IconLogo_1.default, null))))))),
                react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, flexFlow: 'column' },
                    react_1.default.createElement(origyn_art_ui_1.Banner, { color: 'BORDER', fullWidth: true, padding: "8px 24px" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'space-between', fullWidth: true },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 8 },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 13, fontWeight: 400, color: "#151515B2" }, align: "center", gap: 4 }, "Search"),
                                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8 },
                                    react_1.default.createElement(origyn_art_ui_1.TextInput, { value: mapSearch, onChange: (e) => setMapSearch(e.target.value), inputSize: "small", name: "mapSearch" }))),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 32 },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 8 },
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 13, fontWeight: 400, color: "#151515B2" }, align: "center", gap: 4 }, "Filter"),
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8, style: { marginTop: 6 } },
                                        react_1.default.createElement(origyn_art_ui_1.CheckboxInput, { checked: mapFilter === "In", onChange: () => mapFilter === "In" ? setMapFilter("") : setMapFilter("In"), label: "In", name: "inFilter" }),
                                        react_1.default.createElement(origyn_art_ui_1.CheckboxInput, { checked: mapFilter === "Out", onChange: () => mapFilter === "Out" ? setMapFilter("") : setMapFilter("Out"), label: "Out", name: "outFilter" }))),
                                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 8 },
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { as: "p", style: { fontSize: 13, fontWeight: 400, color: "#151515B2" }, align: "center", gap: 4 }, "Transactions"),
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8 },
                                        [10, 50, 100].map((v) => (react_1.default.createElement(origyn_art_ui_1.Button, { size: "medium", className: `${v === mapAmount ? "hover" : ""}`, onClick: () => setMapAmount(v) }, v))),
                                        react_1.default.createElement(origyn_art_ui_1.Button, { size: "medium", className: `${10000 === mapAmount ? "hover" : ""}`, onClick: () => setMapAmount(10000) }, "All")))))),
                    react_1.default.createElement("div", { style: { height: 600, width: "100%" }, ref: ref }),
                    react_1.default.createElement(origyn_art_ui_1.Banner, { color: 'BORDER', fullWidth: true, padding: "16px 32px", flexFlow: 'column', gap: 32 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 32 },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8, align: 'center' },
                                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "33", height: "16", viewBox: "0 0 33 16", fill: "none" },
                                    react_1.default.createElement("path", { d: "M32.3536 8.35356C32.5488 8.1583 32.5488 7.84171 32.3536 7.64645L29.1716 4.46447C28.9763 4.26921 28.6597 4.26921 28.4645 4.46447C28.2692 4.65973 28.2692 4.97632 28.4645 5.17158L31.2929 8.00001L28.4645 10.8284C28.2692 11.0237 28.2692 11.3403 28.4645 11.5355C28.6597 11.7308 28.9763 11.7308 29.1716 11.5355L32.3536 8.35356ZM-8.74228e-08 8.5L2 8.5L2 7.5L8.74228e-08 7.5L-8.74228e-08 8.5ZM6 8.5L10 8.5L10 7.5L6 7.5L6 8.5ZM14 8.5L18 8.5L18 7.5L14 7.5L14 8.5ZM22 8.5L26 8.5L26 7.5L22 7.5L22 8.5ZM30 8.50001L32 8.50001L32 7.50001L30 7.50001L30 8.50001ZM32.7071 8.70711C33.0976 8.31659 33.0976 7.68342 32.7071 7.2929L26.3431 0.928937C25.9526 0.538412 25.3195 0.538412 24.9289 0.928937C24.5384 1.31946 24.5384 1.95263 24.9289 2.34315L30.5858 8.00001L24.9289 13.6569C24.5384 14.0474 24.5384 14.6805 24.9289 15.0711C25.3195 15.4616 25.9526 15.4616 26.3431 15.0711L32.7071 8.70711ZM-1.74846e-07 9L2 9L2 7L1.74846e-07 7L-1.74846e-07 9ZM6 9L10 9L10 7L6 7L6 9ZM14 9L18 9L18 7L14 7L14 9ZM22 9L26 9L26 7L22 7L22 9ZM30 9.00001L32 9.00001L32 7.00001L30 7.00001L30 9.00001Z", fill: "#FB7474" })),
                                react_1.default.createElement("p", null, "Out Transaction")),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8, align: 'center' },
                                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "33", height: "16", viewBox: "0 0 33 16", fill: "none" },
                                    react_1.default.createElement("path", { d: "M32.3536 8.35356C32.5488 8.1583 32.5488 7.84171 32.3536 7.64645L29.1716 4.46447C28.9763 4.26921 28.6597 4.26921 28.4645 4.46447C28.2692 4.65973 28.2692 4.97632 28.4645 5.17158L31.2929 8.00001L28.4645 10.8284C28.2692 11.0237 28.2692 11.3403 28.4645 11.5355C28.6597 11.7308 28.9763 11.7308 29.1716 11.5355L32.3536 8.35356ZM-8.74228e-08 8.5L2 8.5L2 7.5L8.74228e-08 7.5L-8.74228e-08 8.5ZM6 8.5L10 8.5L10 7.5L6 7.5L6 8.5ZM14 8.5L18 8.5L18 7.5L14 7.5L14 8.5ZM22 8.5L26 8.5L26 7.5L22 7.5L22 8.5ZM30 8.50001L32 8.50001L32 7.50001L30 7.50001L30 8.50001ZM32.7071 8.70711C33.0976 8.31659 33.0976 7.68342 32.7071 7.2929L26.3431 0.928937C25.9526 0.538412 25.3195 0.538412 24.9289 0.928937C24.5384 1.31946 24.5384 1.95263 24.9289 2.34315L30.5858 8.00001L24.9289 13.6569C24.5384 14.0474 24.5384 14.6805 24.9289 15.0711C25.3195 15.4616 25.9526 15.4616 26.3431 15.0711L32.7071 8.70711ZM-1.74846e-07 9L2 9L2 7L1.74846e-07 7L-1.74846e-07 9ZM6 9L10 9L10 7L6 7L6 9ZM14 9L18 9L18 7L14 7L14 9ZM22 9L26 9L26 7L22 7L22 9ZM30 9.00001L32 9.00001L32 7.00001L30 7.00001L30 9.00001Z", fill: "#0AB57F" })),
                                react_1.default.createElement("p", null, "In Transaction")),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8, align: 'center' },
                                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "33", height: "16", viewBox: "0 0 33 16", fill: "none" },
                                    react_1.default.createElement("path", { d: "M32.3536 8.35356C32.5488 8.1583 32.5488 7.84171 32.3536 7.64645L29.1716 4.46447C28.9763 4.26921 28.6597 4.26921 28.4645 4.46447C28.2692 4.65973 28.2692 4.97632 28.4645 5.17158L31.2929 8.00001L28.4645 10.8284C28.2692 11.0237 28.2692 11.3403 28.4645 11.5355C28.6597 11.7308 28.9763 11.7308 29.1716 11.5355L32.3536 8.35356ZM-8.74228e-08 8.5L2 8.5L2 7.5L8.74228e-08 7.5L-8.74228e-08 8.5ZM6 8.5L10 8.5L10 7.5L6 7.5L6 8.5ZM14 8.5L18 8.5L18 7.5L14 7.5L14 8.5ZM22 8.5L26 8.5L26 7.5L22 7.5L22 8.5ZM30 8.50001L32 8.50001L32 7.50001L30 7.50001L30 8.50001ZM32.7071 8.70711C33.0976 8.31659 33.0976 7.68342 32.7071 7.2929L26.3431 0.928937C25.9526 0.538412 25.3195 0.538412 24.9289 0.928937C24.5384 1.31946 24.5384 1.95263 24.9289 2.34315L30.5858 8.00001L24.9289 13.6569C24.5384 14.0474 24.5384 14.6805 24.9289 15.0711C25.3195 15.4616 25.9526 15.4616 26.3431 15.0711L32.7071 8.70711ZM-1.74846e-07 9L2 9L2 7L1.74846e-07 7L-1.74846e-07 9ZM6 9L10 9L10 7L6 7L6 9ZM14 9L18 9L18 7L14 7L14 9ZM22 9L26 9L26 7L22 7L22 9ZM30 9.00001L32 9.00001L32 7.00001L30 7.00001L30 9.00001Z", fill: "#74D1EF" })),
                                react_1.default.createElement("p", null, "Includes Initial Transaction"))),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 32, align: 'center' },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, align: 'center' },
                                react_1.default.createElement("div", { style: { width: 16, height: 16, borderRadius: 8, border: "1px solid #5D627B", background: "#8A92B8" } }),
                                react_1.default.createElement("p", null, "Root Account")),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, align: 'center' },
                                react_1.default.createElement("div", { style: { width: 16, height: 16, borderRadius: 8, border: "1px solid #FB7474", background: "#FFF4F4" } }),
                                react_1.default.createElement("p", null,
                                    "Account ",
                                    react_1.default.createElement("br", null),
                                    "(with transactions from root account)")),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, align: 'center' },
                                react_1.default.createElement("div", { style: { width: 16, height: 16, borderRadius: 8, border: "1px solid #0AB57F", background: "#F7FFFC" } }),
                                react_1.default.createElement("p", null,
                                    "Account ",
                                    react_1.default.createElement("br", null),
                                    "(with transactions to root account)")),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, align: 'center' },
                                react_1.default.createElement("div", { style: { width: 16, height: 16, borderRadius: 8, border: "1px solid #74D1EF", background: "#EDFBFF" } }),
                                react_1.default.createElement("p", null,
                                    "Account that made initial transaction",
                                    react_1.default.createElement("br", null)))))),
                react_1.default.createElement(origyn_art_ui_1.Grid, { columns: 2, gap: 32 }, isLoading
                    ? react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Loading_1.LoadingBox, { style: { height: 400 } }),
                        " ",
                        react_1.default.createElement(Loading_1.LoadingBox, { style: { height: 400 } }))
                    : react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", fullWidth: true },
                                react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                                    react_1.default.createElement(CustomBarChart_1.default, { col: 6, chartTitle: "Tx Out", data: timeseries?.txOut, yAxisUnit: 'M OGY', isPageLoading: isLoading, yAxisdivider: format_1.m })))),
                        react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", fullWidth: true },
                                react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                                    react_1.default.createElement(CustomBarChart_1.default, { col: 6, chartTitle: "Tx In", data: timeseries?.txIn, yAxisUnit: 'M OGY', isPageLoading: isLoading, yAxisdivider: format_1.m })))))),
                react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", fullWidth: true },
                        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                            react_1.default.createElement(CustomLineChart_1.default, { stacked: true, data: timeseries?.maxBalance, chartTitle: "Balance", yAxisUnit: 'M OGY', isPageLoading: isLoading, yAxisdivider: format_1.m }))))),
            react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                react_1.default.createElement(Section_1.default, { isLoading: isLoading },
                    react_1.default.createElement(SimpleTable_1.default, { paramKey: "id", dataFetching: (id, n, r) => (0, fetchData_1.getTransactionHistoryById)(id, n, r), initData: history, isPageLoading: isLoading, colWidth: {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        } }))))),
        modalOpenItems && (react_1.default.createElement(origyn_art_ui_1.Modal, { isOpened: !!modalOpenItems, closeModal: handleTransactionsClose },
            react_1.default.createElement(origyn_art_ui_1.Container, { padding: "24px" },
                react_1.default.createElement("br", null),
                react_1.default.createElement("h2", null, "Transactions Details"),
                react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                    react_1.default.createElement(Section_1.default, { isLoading: isLoading },
                        react_1.default.createElement(SimpleTable_1.default, { paramKey: "id", dataFetching: () => ({ data: modalOpenItems?.map(({ data }) => data) }), noPagination: true, initData: ({ data: modalOpenItems?.map(({ data }) => data) }), isPageLoading: isLoading, colWidth: {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            } }))))))));
};
exports.default = LedgerAccountSpecific;
